/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CandidateMini } from './candidateMini';
import type { JobMini } from './jobMini';
import type { LinkedInAccountMini } from './linkedInAccountMini';
import type { SequenceMini } from './sequenceMini';
import type { TaskDetailArchivedReason } from './taskDetailArchivedReason';
import type { TaskDetailCallOutcome } from './taskDetailCallOutcome';
import type { TaskDetailEmailBodyDoc } from './taskDetailEmailBodyDoc';
import type { TaskDetailEmailThreadMode } from './taskDetailEmailThreadMode';
import type { TaskDetailOrigin } from './taskDetailOrigin';
import type { TaskDetailPriority } from './taskDetailPriority';
import type { TaskDetailStatus } from './taskDetailStatus';
import type { TaskDetailTaskNoteDoc } from './taskDetailTaskNoteDoc';
import type { TaskDetailTextOutcome } from './taskDetailTextOutcome';
import type { TaskDetailType } from './taskDetailType';
import type { UserMini } from './userMini';

/**
 * Full payload powering the side-panel.
 */
export interface TaskDetail {
  id: string;
  type: TaskDetailType;
  origin: TaskDetailOrigin;
  status: TaskDetailStatus;
  priority: TaskDetailPriority;
  title: string;
  candidate: CandidateMini;
  job?: JobMini | null;
  sequence?: SequenceMini | null;
  creator?: UserMini | null;
  assignee: UserMini;
  due_at?: string | null;
  scheduled_run_at?: string | null;
  completed_at?: string | null;
  is_read: boolean;
  overdue: boolean;
  job_id: string;
  project_id: string;
  enrollment_id?: string | null;
  step_id?: string | null;
  mailbox_id?: string | null;
  email_to?: string | null;
  email_subject?: string | null;
  email_body_doc?: TaskDetailEmailBodyDoc;
  email_body_html?: string | null;
  email_body_text?: string | null;
  email_thread_mode?: TaskDetailEmailThreadMode;
  email_cc?: string[];
  email_bcc?: string[];
  email_include_sender_signature?: boolean;
  email_include_unsubscribe_link?: boolean;
  email_provider_message_id?: string | null;
  linkedin_account_id?: string | null;
  linkedin_target_url?: string | null;
  linkedin_invitation_note?: string | null;
  linkedin_message_text?: string | null;
  linkedin_include_signature?: boolean;
  linkedin_provider_action_id?: string | null;
  linkedin_already_connected?: boolean | null;
  linkedin_account?: LinkedInAccountMini | null;
  archived_reason?: TaskDetailArchivedReason;
  task_note_doc?: TaskDetailTaskNoteDoc;
  phone_number_used?: string | null;
  call_outcome?: TaskDetailCallOutcome;
  text_outcome?: TaskDetailTextOutcome;
  failure_reason?: string | null;
  archived_at?: string | null;
  created_at: string;
  updated_at: string;
}
